import axios from "axios";

import Config from "src/config";

const v2_actionListaColunasChatsFunil = querys => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chats/funil/lista-colunas${querys}`
    });
};

export default v2_actionListaColunasChatsFunil;
